"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var hw_transport_1 = __importDefault(require("@ledgerhq/hw-transport"));
var errors_1 = require("@ledgerhq/errors");
var logs_1 = require("@ledgerhq/logs");
var WebSocket = global.WebSocket || require("ws");
/**
 * WebSocket transport implementation
 */
var WebSocketTransport = /** @class */ (function (_super) {
    __extends(WebSocketTransport, _super);
    function WebSocketTransport(hook) {
        var _this = _super.call(this) || this;
        _this.hook = hook;
        hook.onDisconnect = function () {
            _this.emit("disconnect");
            _this.hook.rejectExchange(new errors_1.TransportError("WebSocket disconnected", "WSDisconnect"));
        };
        return _this;
    }
    WebSocketTransport.open = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var exchangeMethods;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                            try {
                                var socket_1 = new WebSocket(url);
                                var exchangeMethods_1 = {
                                    resolveExchange: function (_b) { },
                                    rejectExchange: function (_e) { },
                                    onDisconnect: function () { },
                                    close: function () { return socket_1.close(); },
                                    send: function (msg) { return socket_1.send(msg); }
                                };
                                socket_1.onopen = function () {
                                    socket_1.send("open");
                                };
                                socket_1.onerror = function (e) {
                                    exchangeMethods_1.onDisconnect();
                                    reject(e);
                                };
                                socket_1.onclose = function () {
                                    exchangeMethods_1.onDisconnect();
                                    reject(new errors_1.TransportError("OpenFailed", "OpenFailed"));
                                };
                                socket_1.onmessage = function (e) {
                                    if (typeof e.data !== "string")
                                        return;
                                    var data = JSON.parse(e.data);
                                    switch (data.type) {
                                        case "opened":
                                            return resolve(exchangeMethods_1);
                                        case "error":
                                            reject(new Error(data.error));
                                            return exchangeMethods_1.rejectExchange(new errors_1.TransportError(data.error, "WSError"));
                                        case "response":
                                            return exchangeMethods_1.resolveExchange(Buffer.from(data.data, "hex"));
                                    }
                                };
                            }
                            catch (e) {
                                reject(e);
                            }
                        })];
                    case 1:
                        exchangeMethods = _c.sent();
                        return [2 /*return*/, new WebSocketTransport(exchangeMethods)];
                }
            });
        });
    };
    WebSocketTransport.prototype.exchange = function (apdu) {
        return __awaiter(this, void 0, void 0, function () {
            var hex, res;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        hex = apdu.toString("hex");
                        (0, logs_1.log)("apdu", "=> " + hex);
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                _this.hook.rejectExchange = function (e) { return reject(e); };
                                _this.hook.resolveExchange = function (b) { return resolve(b); };
                                _this.hook.send(hex);
                            })];
                    case 1:
                        res = _c.sent();
                        (0, logs_1.log)("apdu", "<= " + res.toString("hex"));
                        return [2 /*return*/, res];
                }
            });
        });
    };
    WebSocketTransport.prototype.setScrambleKey = function () { };
    WebSocketTransport.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                this.hook.close();
                return [2 /*return*/, new Promise(function (success) {
                        setTimeout(function () {
                            success(undefined);
                        }, 200);
                    })];
            });
        });
    };
    var _a;
    _a = WebSocketTransport;
    WebSocketTransport.isSupported = function () {
        return Promise.resolve(typeof WebSocket === "function");
    };
    // this transport is not discoverable
    WebSocketTransport.list = function () { return Promise.resolve([]); };
    WebSocketTransport.listen = function (_observer) { return ({
        unsubscribe: function () { }
    }); };
    WebSocketTransport.check = function (url, timeout) {
        if (timeout === void 0) { timeout = 5000; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(_a, function (_c) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var socket = new WebSocket(url);
                        var success = false;
                        setTimeout(function () {
                            socket.close();
                        }, timeout);
                        socket.onopen = function () {
                            success = true;
                            socket.close();
                        };
                        socket.onclose = function () {
                            if (success)
                                resolve(undefined);
                            else {
                                reject(new errors_1.TransportError("failed to access WebSocketTransport(" + url + ")", "WebSocketTransportNotAccessible"));
                            }
                        };
                        socket.onerror = function () {
                            reject(new errors_1.TransportError("failed to access WebSocketTransport(" + url + "): error", "WebSocketTransportNotAccessible"));
                        };
                    })];
            });
        });
    };
    return WebSocketTransport;
}(hw_transport_1["default"]));
exports["default"] = WebSocketTransport;
//# sourceMappingURL=WebSocketTransport.js.map